const middleware = {}

middleware['adminAuthRequired'] = require('../../../middleware/adminAuthRequired.ts')
middleware['adminAuthRequired'] = middleware['adminAuthRequired'].default || middleware['adminAuthRequired']

middleware['authenticated'] = require('../../../middleware/authenticated.ts')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['breadcrumbsReset'] = require('../../../middleware/breadcrumbsReset.ts')
middleware['breadcrumbsReset'] = middleware['breadcrumbsReset'].default || middleware['breadcrumbsReset']

middleware['cleanExpiredFormBackups'] = require('../../../middleware/cleanExpiredFormBackups.ts')
middleware['cleanExpiredFormBackups'] = middleware['cleanExpiredFormBackups'].default || middleware['cleanExpiredFormBackups']

middleware['defaultQuery'] = require('../../../middleware/defaultQuery.ts')
middleware['defaultQuery'] = middleware['defaultQuery'].default || middleware['defaultQuery']

middleware['patientAuthRequired'] = require('../../../middleware/patientAuthRequired.ts')
middleware['patientAuthRequired'] = middleware['patientAuthRequired'].default || middleware['patientAuthRequired']

middleware['restrictClinicAccess'] = require('../../../middleware/restrictClinicAccess.ts')
middleware['restrictClinicAccess'] = middleware['restrictClinicAccess'].default || middleware['restrictClinicAccess']

middleware['setAvailableLanguages'] = require('../../../middleware/setAvailableLanguages.ts')
middleware['setAvailableLanguages'] = middleware['setAvailableLanguages'].default || middleware['setAvailableLanguages']

export default middleware
